<template>
  <div class="delete-outer-blk">
    <div class="delete-inner-blk">
      <div class="delete-inner-modal">

        <div class="taski-image-blk">
          <img src='../../assets/assets/images/taski-logo.png' class="image-blk" alt="taSki">
        </div>

        <div class="taski-name-blk">
          ta<span>S</span>ki Vendor
        </div>

        <div class="page-title-blk">Delete Your Account</div>

        <div class="section-blk">
          <div class="section-head-blk">How to request deletion</div>
          <p>
            To permanently delete your ta<span class="accent">S</span>ki Vendor account and the data linked to it,
            send a deletion request from the mobile number or email address registered with your account.
          </p>
          <div class="contact-list-blk">
            <div class="contact-row-blk">
              <span class="contact-icon-blk"><i class="fas fa-envelope"></i></span>
              <a :href="'mailto:' + contact.email + '?subject=' + mailSubject">{{ contact.email }}</a>
            </div>
            <div class="contact-row-blk">
              <span class="contact-icon-blk"><i class="fas fa-phone-alt"></i></span>
              <a :href="'tel:' + contact.phone">{{ contact.phone }}</a>
            </div>
          </div>
          <p class="note-blk">
            Please include your registered mobile number and your vendor name in the request so we can verify
            that the account belongs to you.
          </p>
        </div>

        <div class="section-blk">
          <div class="section-head-blk">What gets deleted</div>
          <ul>
            <li v-for="(item, index) in deletedData" :key="'del-' + index">{{ item }}</li>
          </ul>
        </div>

        <div class="section-blk">
          <div class="section-head-blk">What we keep, and for how long</div>
          <ul>
            <li v-for="(item, index) in retainedData" :key="'keep-' + index">{{ item }}</li>
          </ul>
          <p class="note-blk">
            Retained records are kept only to meet legal, tax and accounting obligations, and are removed once
            the applicable retention period ends.
          </p>
        </div>

        <div class="section-blk">
          <div class="section-head-blk">How long it takes</div>
          <p>
            We verify and action deletion requests within <strong>7 working days</strong>. Once the account is
            deleted you will be signed out of the app and the account cannot be recovered.
          </p>
        </div>

        <div class="warning-blk">
          <span class="warning-icon-blk"><i class="fas fa-exclamation-triangle"></i></span>
          <span>Account deletion is permanent. Any trips, documents and vehicle records tied to the account are
            removed and cannot be restored.</span>
        </div>

        <div class="footer-blk">
          Need help before deleting? Reach us at
          <a :href="'mailto:' + contact.email">{{ contact.email }}</a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DeleteAccount",
  data: () => {
    return {
      // TODO: replace with the live taSki support contact details
      contact: {
        email: 'support@taskicabs.com',
        phone: '+91 00000 00000',
      },
      mailSubject: 'Account%20Deletion%20Request%20-%20taSki%20Vendor',

      deletedData: [
        'Your vendor profile — name, mobile number, email address and login credentials',
        'Driver records added under your account, including their profile and contact details',
        'Vehicle records and the documents uploaded against them',
        'Uploaded documents and images such as licence, RC, insurance and permit copies',
        'Saved app preferences and push notification tokens',
      ],
      retainedData: [
        'Completed trip and booking records, retained for up to 7 years',
        'Invoices, payment and settlement records, retained for up to 7 years',
        'Records we are required to keep under applicable law or by a regulatory authority',
      ],
    }
  },
}
</script>

<style scoped lang="scss">
.delete-outer-blk {
  background-color: #fcd34d;
  min-height: 100vh;

  .delete-inner-blk {
    display: flex;
    justify-content: center;
    padding: 40px 15px;

    .delete-inner-modal {
      background-color: white;
      padding: 50px;
      width: 46%;
      border-radius: 5px;
      color: #4e4e4e;
      font-family: 'Muli', sans-serif;

      @media (max-width: 1399px) {
        width: 60%;
      }
      @media (max-width: 991px) {
        width: 100%;
        padding: 30px 20px;
      }

      .taski-image-blk {
        display: flex;
        justify-content: center;
        margin-bottom: 20px;

        .image-blk {
          max-height: 70px;
        }
      }

      .taski-name-blk {
        text-align: center;
        font-weight: bold;
        font-size: 20px;
        font-family: Corbel;

        span {
          color: #eea004;
        }
      }

      .page-title-blk {
        text-align: center;
        font-weight: bold;
        font-size: 26px;
        color: #000;
        margin-top: 25px;
        padding-bottom: 20px;
        border-bottom: 1px solid #f0f0f0;

        @media (max-width: 991px) {
          font-size: 22px;
        }
      }

      .section-blk {
        margin-top: 28px;

        .section-head-blk {
          font-weight: bold;
          font-size: 17px;
          color: #000;
          margin-bottom: 10px;
        }

        p {
          font-size: 15px;
          line-height: 1.6;
          margin-bottom: 10px;
        }

        ul {
          padding-left: 20px;

          li {
            font-size: 15px;
            line-height: 1.6;
            margin-bottom: 6px;
          }
        }

        .note-blk {
          font-size: 14px;
          color: #7a7a7a;
        }

        .accent {
          color: #eea004;
        }
      }

      .contact-list-blk {
        background-color: #f5f4f4;
        border-radius: 5px;
        padding: 15px;
        margin: 15px 0;

        .contact-row-blk {
          display: flex;
          align-items: center;
          font-size: 15px;
          font-weight: bold;

          &:not(:last-child) {
            margin-bottom: 10px;
          }

          .contact-icon-blk {
            width: 30px;
            text-align: center;
            color: #eea004;
          }

          a {
            color: #4e4e4e;
            text-decoration: none;
            word-break: break-all;

            &:hover {
              color: #eea004;
            }
          }
        }
      }

      .warning-blk {
        display: flex;
        align-items: flex-start;
        background-color: #fff8e6;
        border-left: 4px solid #eea004;
        border-radius: 5px;
        padding: 15px;
        margin-top: 28px;
        font-size: 14px;
        line-height: 1.6;

        .warning-icon-blk {
          margin-right: 10px;
          color: #eea004;
        }
      }

      .footer-blk {
        margin-top: 28px;
        padding-top: 20px;
        border-top: 1px solid #f0f0f0;
        text-align: center;
        font-size: 14px;
        color: #7a7a7a;

        a {
          color: #eea004;
          text-decoration: none;
          word-break: break-all;
        }
      }
    }
  }
}
</style>
